import React from 'react';

const ErrorSystemEP504 = () => {
  return (
    <div className="ep_panel">
      <div className="ep_error_504_wrap">
        <img src="../assets/images/illust/illust-login-EP-504error.jpg" alt="시스템 점검 중" className="ep_error_504_img" />
      </div>
    </div>
  );
};

export default ErrorSystemEP504;
